module.exports = __webpack_public_path__ + "img/8.0d3dd09d.webp";